export default __webpack_public_path__ + "static/media/imgfallbackLarge.e851bfb2.jpg";